// extracted by css-extract-rspack-plugin
module.exports =  {"spouse":"Spouse__spouse--OPu8l Form__box--BfBHj","OtherSalaryIncome":"Spouse__OtherSalaryIncome--WC7eE","close":"Spouse__close--Zxc4v","open":"Spouse__open--Yvibw"};